import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MainService } from 'src/app/services/main.service'

import { SharedModule } from '../shared/shared.module'
import { DistributionsComponent } from './distributions.component'
import { DistributionsService } from './distributions.service'

@NgModule({
  declarations: [DistributionsComponent],
  imports: [CommonModule, SharedModule, NgbModule, FormsModule],
  exports: [DistributionsComponent],
  providers: [MainService, DistributionsService],
})
export class DistributionsModule {}
